export default __webpack_public_path__ + "27f2e09f50a255c87175e0583aa20caa.png";